import { Image, Platform } from 'react-native';
import useGetImageUrl from '../../hooks/useGetImageUrl/useGetImageUrl';

type Props = {
  base64: string;
  width?: number;
  height?: number;
};

export default function Base64Image({ base64, width = 150, height = 150 }: Props) {
  const blobUrl = useGetImageUrl(base64);

  if (Platform.OS === 'web') {
    if(!blobUrl) return null;
    return (
      <img
        src={blobUrl}
        style={{ width, height, objectFit: 'contain' }}
        alt=""
      />
    );
  }

  // Mobile
  return (
    <Image
      source={{ uri: base64 }}
      width={width}
      height={height}
      resizeMode="contain"
    />
  );
}